import { getDistance } from "../BoundedMap";

export const filterNearestAssets = (assets, targetAsset, maxCount) => {
  const listWithDistance = assets.map(asset => ({
    distance: getDistance(asset.geo, targetAsset.geo),
    asset,
  }));
  return listWithDistance
    .sort((a, b) => {
      return a.distance - b.distance;
    })
    .filter(({ asset }) => asset.assetId !== targetAsset.assetId)
    .slice(0, maxCount)
    .map(item => item.asset);
};


// WEBPACK FOOTER //
// ./lib/masterUtil/filterNearestAssets.js